export interface NewMessageContext {
  contactId?: string | number | null;
  accountId?: string | number | null;
  returnTo?: string | null;
}

export function buildNewMessageParams(
  context: NewMessageContext = {}
): URLSearchParams {
  const params = new URLSearchParams();

  if (context.contactId) {
    params.set('contactId', String(context.contactId));
  }
  if (context.accountId) {
    params.set('accountId', String(context.accountId));
  }
  if (
    context.returnTo?.startsWith('/') &&
    !context.returnTo.startsWith('//') &&
    !context.returnTo.includes('\\')
  ) {
    params.set('returnTo', context.returnTo);
  }

  return params;
}

export function buildNewMessageUrl(
  baseUrl: string,
  context: NewMessageContext = {}
): string {
  const hashIndex = baseUrl.indexOf('#');
  const urlWithoutHash =
    hashIndex === -1 ? baseUrl : baseUrl.slice(0, hashIndex);
  const hash = hashIndex === -1 ? undefined : baseUrl.slice(hashIndex + 1);
  const [path, existingQuery] = urlWithoutHash.split('?', 2);
  const params = new URLSearchParams(existingQuery);

  buildNewMessageParams(context).forEach((value, key) =>
    params.set(key, value)
  );

  const query = params.toString();
  return `${path}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
}

export function navigateToNewMessage(
  baseUrl: string,
  context: NewMessageContext = {}
): void {
  const url = buildNewMessageUrl(baseUrl, context);
  window.location.href = url;
}
